<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [title]="'MENUITEMS.ATTENDANCE.TEXT' | translate"
                      [items]="[('workCyclesCatalog.breadcrumb' | translate)]"></app-breadcrumb>
    </div>

    <div class="work-cycle-list-workspace">
      <app-master-table
        [title]="'workCyclesCatalog.title' | translate"
        [dataSource]="dataSource"
        [columnDefinitions]="columnDefinitions"
        [actions]="actions"
        [filters]="tableFilters"
        [isLoading]="isLoading"
        [enableRowClick]="false"
        [rowClickSelection]="true"
        [showContextMenu]="false"
        [tableMaxHeight]="'560px'"
        [exportFileName]="'work-cycles'"
        (add)="handleAdd()"
        (refresh)="loadData()"
        (details)="handleView($event)"
        (edit)="handleEdit($event)"
        (delete)="handleDelete($event)"
        (bulkDelete)="handleBulkDelete($event)"
        (searchChange)="onSearchChange($event)"
        (filtersChange)="onFiltersChange($event)">
      </app-master-table>
    </div>
  </div>
</section>
